import Text from './Text';

export { Text };
export default Text;
